export const sortByPtBR = (list, getKey = (item) => item) => {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const aKey = getKey(a);
    const bKey = getKey(b);
    if (aKey == null && bKey == null) return 0;
    if (aKey == null) return 1;
    if (bKey == null) return -1;
    return String(aKey).localeCompare(String(bKey), "pt-BR", { sensitivity: "base" });
  });
};
